import { useNavigationAdapter } from './NavigationContext';

/**
 * Hook to get URL search parameters
 * Uses the navigation adapter injected by NavigationProvider
 *
 * @returns URLSearchParams object
 *
 * @example
 * ```tsx
 * function MyComponent() {
 *   const searchParams = useSearchParams();
 *   const redirectUrl = searchParams.get('redirect') || '/';
 *   // ...
 * }
 * ```
 */
export function useSearchParams(): URLSearchParams {
  const adapter = useNavigationAdapter();
  return adapter.useSearchParams();
}
